import $ from "jquery"

function initPhotoChanger() {
    let currentIndex = 0;
    const $images = $(".tplabout .ctrphoto img");
    
    // Initially hide all except the first image
    $images.hide().eq(currentIndex).show();

    window.setInterval(function() {
        $images.eq(currentIndex).fadeOut(500, function() {
            currentIndex = (currentIndex + 1) % $images.length;
            $images.eq(currentIndex).fadeIn(500);
        });
    }, 4000);
}

$(function() {
    if($(".tplabout").length > 0) {
        initPhotoChanger();
    }
});